import React from 'react'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Spinner from 'react-bootstrap/Spinner'

const ActionButton = ({
  icon,
  label,
  onClick,
  variant = 'primary',
  size = 'sm',
  className = '',
  iconClassName = '',
  disabled = false,
  loading = false,
  loadingLabel,
  'data-testid': dataTestId,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={dataTestId}
      {...rest}
    >
      {loading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-1"
          />
          {loadingLabel || label}
        </>
      ) : (
        <>
          {icon && <FontAwesomeIcon icon={icon} className={`${iconClassName}${label ? ' me-1' : ''}`} />}
          {label}
        </>
      )}
    </Button>
  )
}

export default ActionButton
